import { BILLS_TABLE_COLUMN_KEYS } from './consts';

export const BILLS_TABLE_STYLES = {
  TableTitle: 'font-metricR text-sm text-bw07 mb-[12px]',
  TableTitleAddon: 'font-metricR text-sm text-bw06 ml-[5px]',
  TableRowWrapper: '',
  DueDateSubtitle: 'text-red02',
  TableTHead: 'top-0',
  TableHeaderWrapper: 'flex h-[40px] items-center border-t bg-bw01',
  TableLastRowStyle: 'rounded-s-lg',
  TableHeaderCell: 'h-[40px] flex items-center align-middle bg-bw01 border-t border-b border-bw03 font-normal',
  TableHeaderCellText: 'text-sm text-bw07 font-metricR',
  TableBodyCellText: 'text-sm text-bw08 font-metricR font-normal',
  TableBodyCell: 'h-[64px] border-b-[1px] border-bw03 flex flex-col justify-center box-border',
};

export const BILLS_TABLE_HEADER_STYLES = {
  TableTH: 'p-0',
  TableTHead: 'top-0',
};

export const BILLS_HEADER_CELL_STYLES = {
  [BILLS_TABLE_COLUMN_KEYS.BILL_NUMBER]: `pl-6 border-l border-bw03 rounded-tl-lg ${BILLS_TABLE_STYLES.TableHeaderCell} ${BILLS_TABLE_STYLES.TableHeaderCellText}`,
  [BILLS_TABLE_COLUMN_KEYS.VENDOR_NAME]: `${BILLS_TABLE_STYLES.TableHeaderCell} ${BILLS_TABLE_STYLES.TableHeaderCellText} flex-[1_0_23%]`,
  [BILLS_TABLE_COLUMN_KEYS.DUE_DATE]: `${BILLS_TABLE_STYLES.TableHeaderCell} ${BILLS_TABLE_STYLES.TableHeaderCellText} flex-[1_0_16%]`,
  [BILLS_TABLE_COLUMN_KEYS.STATUS]: `${BILLS_TABLE_STYLES.TableHeaderCell} ${BILLS_TABLE_STYLES.TableHeaderCellText} flex-[0_0_19%] justify-center text-center px-[10px]`,
  [BILLS_TABLE_COLUMN_KEYS.ATTACHMENT]: `${BILLS_TABLE_STYLES.TableHeaderCell} ${BILLS_TABLE_STYLES.TableHeaderCellText} flex-[0_0_8%] justify-center`,
  [BILLS_TABLE_COLUMN_KEYS.AMOUNT]: `border-bw03 ${BILLS_TABLE_STYLES.TableHeaderCell} ${BILLS_TABLE_STYLES.TableHeaderCellText} flex-[0_0_13%] px-[12px] justify-end`,
  [BILLS_TABLE_COLUMN_KEYS.ACTION]: `border-r border-bw03 rounded-tr-lg ${BILLS_TABLE_STYLES.TableHeaderCell} ${BILLS_TABLE_STYLES.TableHeaderCellText} flex-[0_0_8%] px-[12px]`,
};

export const BILLS_BODY_CELL_STYLES = {
  [BILLS_TABLE_COLUMN_KEYS.BILL_NUMBER]: `w-[145px] pl-6 border-l-[2px] border-l-action03 ${BILLS_TABLE_STYLES.TableBodyCell} ${BILLS_TABLE_STYLES.TableBodyCellText}`,
  [BILLS_TABLE_COLUMN_KEYS.VENDOR_NAME]: `${BILLS_TABLE_STYLES.TableBodyCell} ${BILLS_TABLE_STYLES.TableBodyCellText}`,
  [BILLS_TABLE_COLUMN_KEYS.DUE_DATE]: `w-[194px] ${BILLS_TABLE_STYLES.TableBodyCell} ${BILLS_TABLE_STYLES.TableBodyCellText}`,
  [BILLS_TABLE_COLUMN_KEYS.STATUS]: `w-[207px] ${BILLS_TABLE_STYLES.TableBodyCell} ${BILLS_TABLE_STYLES.TableBodyCellText} text-center items-center px-[10px]`,
  [BILLS_TABLE_COLUMN_KEYS.ATTACHMENT]: `w-[94px] ${BILLS_TABLE_STYLES.TableBodyCell} ${BILLS_TABLE_STYLES.TableBodyCellText} text-center px-[10px]`,
  [BILLS_TABLE_COLUMN_KEYS.AMOUNT]: `w-[142px] ${BILLS_TABLE_STYLES.TableBodyCell} ${BILLS_TABLE_STYLES.TableBodyCellText} text-right px-[12px]`,
  [BILLS_TABLE_COLUMN_KEYS.ACTION]: `w-[77px] pr-6 border-r-[1px] border-bw03 items-center ${BILLS_TABLE_STYLES.TableBodyCell} ${BILLS_TABLE_STYLES.TableBodyCellText} px-[10px]`,
};

export const WIDGET_BILLS_BODY_CELL_STYLES = {
  [BILLS_TABLE_COLUMN_KEYS.BILL_NUMBER]: `w-[128px] pl-3 h-[60px] flex flex-col justify-center box-border ${BILLS_TABLE_STYLES.TableBodyCellText}`,
  [BILLS_TABLE_COLUMN_KEYS.VENDOR_NAME]: `w-[152px] pl-2 h-[60px] flex flex-col justify-center box-border ${BILLS_TABLE_STYLES.TableBodyCellText}`,
  [BILLS_TABLE_COLUMN_KEYS.DUE_DATE]: `w-auto pl-3 h-[60px] flex flex-col justify-center box-border ${BILLS_TABLE_STYLES.TableBodyCellText}`,
  [BILLS_TABLE_COLUMN_KEYS.STATUS]: `min-w-[119px] pl-3 h-[60px] flex flex-col justify-center box-border ${BILLS_TABLE_STYLES.TableBodyCellText} text-center items-center px-[10px]`,
  [BILLS_TABLE_COLUMN_KEYS.AMOUNT]: `w-full px-3 h-[60px] flex flex-col justify-center box-border ${BILLS_TABLE_STYLES.TableBodyCellText} text-right`,
};
